module.exports = __webpack_public_path__ + "static/media/FrontendDev.557c90e1.jpg";